import React from "react";
import { interpolate, useCurrentFrame, Easing } from "remotion";

export interface SlidingHighlightProps {
  children: React.ReactNode;
  delay?: number;
  durationInFrames?: number;
  highlightColor?: string;
  textColor?: string;
  style?: React.CSSProperties;
}

/**
 * SlidingHighlight Component
 * Kotak highlight yang menyapu masuk di belakang teks penekanan.
 */
export const SlidingHighlight: React.FC<SlidingHighlightProps> = ({
  children,
  delay = 0,
  durationInFrames = 20,
  highlightColor = "#e8f36e",
  textColor = "#070908",
  style,
}) => {
  const frame = useCurrentFrame();

  const progress = interpolate(
    frame - delay,
    [0, durationInFrames],
    [0, 100],
    {
      easing: Easing.bezier(0.16, 1, 0.3, 1),
      extrapolateLeft: "clamp",
      extrapolateRight: "clamp",
    }
  );

  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        padding: "2px 8px",
        ...style,
      }}
    >
      <span
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          width: `${progress}%`,
          backgroundColor: highlightColor,
          borderRadius: "6px",
          zIndex: 1,
        }}
      />
      <span
        style={{
          position: "relative",
          zIndex: 2,
          color: progress > 50 ? textColor : "inherit",
          transition: "color 0.15s ease",
          fontWeight: 800,
        }}
      >
        {children}
      </span>
    </span>
  );
};
